<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.product_log">
  <div class="banner center" style="max-width:600px;" *ngIf="items">
    <div class="row_header freeze_height">
      <div class="row">
        <div class="col-6">
          {{localService.languageContent.product_log.total_products}}
        </div>
        <div class="col-6">
          {{localService.languageContent.table.created_on}}/{{localService.languageContent.table.updated_on}}
          <div class="icon_action_header">
            <button class="button_icon button_icon_color" (click)="onLoad()" style="top: 0px;
            height: 30px;">replay_circle_filled</button>
          </div>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of items">
        <div class="col-6">
          <a class="button" [routerLink]="['/product-log-details' + localService.basicParamsString,item.key]"><i
              class="material-icons button icon_adjust">account_tree</i></a>
          <span class="en" *ngIf="item.v3 != item.v1">&nbsp;{{item.v3}}/{{item.v1}}&nbsp;</span>
          <span class="en" *ngIf="item.v3 == item.v1">&nbsp;{{item.v1}}&nbsp;</span>
          <button class="button_icon button_icon_color" *ngIf="item.v4 == '1'" style="top: 7px;
          height: 30px;" (click)="onAction(1,item.v5)">repeat_one</button>
        </div>
        <div class="col-6">
          <span class="en">{{(item.v7 == '2' ? item.v6 : item.v2) | localDate}}</span>
        </div>
      </div>
    </div>
  </div>
</div>